import { Html } from '@react-three/drei';
import type { ReactNode } from 'react';

/**
 * Fullscreen HTML overlay pinned to the canvas viewport.
 *
 * Plain <Html fullscreen> re-translates its wrapper to the HOST OBJECT's
 * projected screen position every frame (default host: the world origin),
 * so children drawing canvas-local pixel coordinates drift with the camera
 * — an orbit/pan/zoom moves the wrapper and the overlay no longer sits
 * under the cursor. Overriding calculatePosition pins the wrapper to the
 * canvas center; combined with fullscreen's negative top/left half-size
 * offset the wrapper then exactly covers the canvas, so child left/top
 * values become true canvas-local pixels regardless of the camera pose.
 */
export function SketchCanvasOverlayHtml({ children }: { children: ReactNode }) {
    return (
        <Html
            fullscreen
            zIndexRange={[8, 0]}
            style={{ pointerEvents: 'none' }}
            calculatePosition={(_object, _camera, size) => [size.width / 2, size.height / 2]}
        >
            {children}
        </Html>
    );
}
